/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingPriceBandOutput
 */
export interface BookingPriceBandOutput {
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandOutput
     */
    markupAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandOutput
     */
    markupPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandOutput
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandOutput
     */
    min?: number;
}

export function BookingPriceBandOutputFromJSON(json: any): BookingPriceBandOutput {
    return BookingPriceBandOutputFromJSONTyped(json, false);
}

export function BookingPriceBandOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingPriceBandOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
    };
}

export function BookingPriceBandOutputToJSON(value?: BookingPriceBandOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'max': value.max,
        'min': value.min,
    };
}


